<template>
    <div>
        <!--顶部 start -->
        <head-page></head-page>
        <!--顶部 end -->

        <!--定位的顶部 start -->
        <transition name="head">
            <div v-if="headerFlag" class="position_class">
                <head-page></head-page>
            </div>
        </transition>
        <!--定位的顶部 end -->

        <!--中间 start -->
        <transition mode='out-in'>
            <router-view></router-view>
        </transition>
        <!--中间 end -->

        <!--底部 start -->
        <footer-page></footer-page>
        <!--底部 end -->
    </div>
</template>

<script>
    import HeadPage from "./components/headPage";
    import FooterPage from "./components/footerPage";

    export default {
        name: "layout",
        components: {
            HeadPage, FooterPage
        },
        data() {
            return {
                throttleFlag: null,
                headerFlag: false,
            }
        },
        methods: {
            onScroll() {
                let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                scrollTop > 70 ? this.headerFlag = true : this.headerFlag = false;
            }
        },
        mounted() {
            this.$nextTick(function () {
                window.addEventListener('scroll', this.onScroll)
            })

        }
    }

</script>

<style lang="scss" scoped>
    .head-enter-active {
        transition: all .3s;
    }
    .head-leave-active {
        transition: all .3s;
    }
    .head-enter, .head-leave-to {
        height: 0px;
    }
    .head-enter-to, .head-leave {
        height: 100px;
    }
    .position_class {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        overflow: hidden;
        background: #ffffff;
        z-index:300;
    }
</style>